export default "__VITE_PUBLIC_ASSET__6d8168c3__"